export const navigationConstants = {
  NAVIGATION_TOGGLE: 'NAVIGATION_TOGGLE',
}
